// @flow
// @flow-runtime warn
import { useCallback, useState, useEffect } from 'react';
import isEmpty from 'ramda/es/isEmpty';

import { api, requestsGeneral } from 'app/api';

import useSchools from '../useSchools';
import type { StatementsType } from './StatementsTypes';
import type { RecipientsType } from '../RecipientsData';


export default function useCheckStatementsEnabled(skip?: boolean) {
  const [statementsEnabled, setStatementsEnabled] = useState(false);
  const [recipientsEnabled, setRecipientsEnabled] = useState(false);
  const [, schoolsIds] = useSchools();


  const handleRequestStatements = useCallback(async () => {
    const statementsRes: StatementsType | null = await api.request(requestsGeneral.Statements_GET_posts, {
      error: 'Не удалось получить обращения',
      params: {
        limit: 1, // достаточно одного значения, чтоб узнать есть ли элементы
        offset: 0,
      },
    });
    setStatementsEnabled(!isEmpty(statementsRes));
  }, []);

  const handleRequestRecipients = useCallback(async (schoolIds_: ?Array<number>) => {
    if (!schoolIds_ || isEmpty(schoolIds_)) return;
    const recipientsRes: RecipientsType | null = await api.request(
      requestsGeneral.Statements_GET_recipients, {
        error: 'Не удалось запросить список получателей',
        params: {
          school_id: schoolIds_,
          deleted: false,
        },
      }
    );
    setRecipientsEnabled(!isEmpty(recipientsRes));
  }, []);


  // autorequest on mount
  useEffect(() => {
    if (!skip) {
      handleRequestStatements();
      handleRequestRecipients(schoolsIds);
    }
  }, [schoolsIds]);

  return skip ? false : statementsEnabled || recipientsEnabled;
}
